export default __webpack_public_path__ + "static/media/LY.3665cd21.svg";